import React from 'react';
import imgAbout from "../assets/section.webp"

const HHTAbout = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-12 md:mb-0 md:pr-12">
            <h2 className="text-3xl font-bold text-purple-900 mb-6">¿Quiénes somos?</h2>
            <p className="text-gray-700 mb-8 text-lg">
              Somos especialistas en atracción y selección de personal. Nuestra pasión es encontrar al talento ideal que no solo cumpla con los requisitos, sino que conecte con los valores y metas de tu organización.
            </p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-purple-100 p-2 rounded-full mr-4">
                  <svg className="w-6 h-6 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">+10 años de experiencia</span>
              </li>
              <li className="flex items-start">
                <div className="bg-purple-100 p-2 rounded-full mr-4">
                  <svg className="w-6 h-6 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Cobertura nacional e internacional</span>
              </li>
              <li className="flex items-start">
                <div className="bg-purple-100 p-2 rounded-full mr-4">
                  <svg className="w-6 h-6 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Proceso 100% personalizado</span>
              </li>
            </ul>
          </div>
          <div className="md:w-1/2">
            {/* Imagen placeholder - reemplazar con imagen real */}
            {/* <div className="bg-gray-200 rounded-xl h-96 w-full"></div> */}
            <img src={imgAbout} alt="About" className="bg-gray-200 rounded-xl object-cover h-96 w-full" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HHTAbout;